$( function() {
	$('.admin').find('ul.gallery').on('click', 'a.btn-delete-image', function(e) {
		e.preventDefault();
		$image_tile = $(this).closest('li');
		var url = $(this).attr('href');

		$.post(url, {}, function(res) {
			console.log(res);
			if(!res.error) {
				$image_tile.fadeOut().remove();
			}
		});
	});

	$('ul.gallery').on('click', 'a.btn-publish-image', function(e) {
		e.preventDefault();
		$image_tile = $(this).closest('li');
		var url = $(this).attr('href');

		$.post(url, {}, function(res) {
			console.log(res);
			if(!res.error) {
				$image_tile.addClass('published');
			}
		});
	});

	$('ul.gallery').on('click', 'a.btn-unpublish-image', function(e) {
		e.preventDefault();
		$image_tile = $(this).closest('li');
		var url = $(this).attr('href');

		$.post(url, {}, function(res) {
			console.log(res);
			if(!res.error) {
				$image_tile.removeClass('published');
			}
		});
	});
});